/**
 * Shared form constants. Team data lives in src/content/team.js; site-wide
 * config (nav, company facts) in src/content/site.js.
 */

export const optionsForWhatsDescribesYou = [
  { value: 'Physician (PM&R)', label: 'Physician (PM&R)' },
  { value: 'Advanced Practice Provider', label: 'Advanced Practice Provider' },
  { value: 'Hospital or health-system leader', label: 'Hospital or health-system leader' },
  { value: 'Patient or family member', label: 'Patient or family member' },
  { value: 'Other', label: 'Other' },
];
